import { LocationStatus } from '../../domain/GeolocatedTransport';
import { vesselStatus } from '../../domain/GeolocatedVessel';

interface GeolocatedVesselsDTO {
  imo: string;
  name: string;
  lastLocationCoordinates: { longitude: number; latitude: number };
  origin: string;
  originCountry: string;
  originPortExitDate: string;
  destination: string;
  destinationCountry: string;
  eta: string;
  updateDate: string;
  status: LocationStatus;
  vins: string[];
  portArrivalInfo: string;
  currentCountry: string;
  currentPort: string;
  vesselStatus: vesselStatus;
}

interface ApiVesselDTO extends Omit<GeolocatedVesselsDTO, 'vesselStatus'> {
  statusSnowflake: vesselStatus;
}

class GeolocatedVesselsResponseDTO {
  vessels: GeolocatedVesselsDTO[];

  constructor({ vessels }: { vessels: ApiVesselDTO[] }) {
    this.vessels = vessels.map(({ statusSnowflake, ...rest }) => ({
      ...rest,
      vesselStatus: statusSnowflake
    }));
  }
}

export default GeolocatedVesselsResponseDTO;
